{
    "proxy": {
        "actions": {
            "copy": "Copiar proxy",
            "delete": "Eliminar proxy",
            "import": "Importar proxies",
            "restore": "Restaurar proxy",
            "speedtest": "Teste de velocidade"
        },
        "import": {
            "added": "Proxy adicionado",
            "placeholder": "Formato: 'nome, tipo, ip, porta, login, password'. Ex. 'Italy, HTTP, 172.0.0.1, 2222, username, pass'",
            "resultTitle": "Resultado",
            "title": "Importar Proxies (Formato: \"nome, tipo, ip, porta, login, password\". Ex. \"Italy, HTTP, 172.0.0.1, 2222, username, pass\")",
            "upload": "Carregar"
        },
        "importIncorectFormat": "Formato incorreto (nome, tipo, ip, porta, login, password)",
        "importWrongProxyPort": "Porta de proxy incorreta. Deve ser um número",
        "importWrongProxyType": "Tipo de proxy incorreto. Deve ser HTTP, SOCKS5 ou IP",
        "confirmDelete": "Eliminar este proxy?",
        "confirmRestore": "Restaurar este proxy?",
        "dataError": "Erro",
        "speedtest": {
            "directLine": "Tempo direto: {connect}s, Tempo total: {total}s",
            "failed": "Falhou",
            "proxyLine": "Tempo de ligação: {connect}s, Tempo total: {total}s",
            "realIp": "IP real: {ip}",
            "realIpUnknown": "Desconhecido",
            "runTest": "Executar teste",
            "title": "Teste de velocidade do proxy. Selecionar sites"
        },
        "bulk": {
            "apply": "Definir",
            "confirmDelete": "Eliminar {count} proxy(s) selecionado(s)?",
            "confirmSetBookmakers": "Definir casas de apostas para {count} proxy(s) selecionado(s)?",
            "delete": "Eliminar",
            "setBookmakers": "Definir casas de apostas"
        },
        "form": {
            "country": "País",
            "countryPlaceholder": "Não selecionado",
            "createTitle": "Adicionar proxy",
            "editTitle": "Editar proxy",
            "ip": "Ip / Hostname",
            "isActive": "Ativo",
            "isAgent": "Agente",
            "login": "Login",
            "name": "Nome",
            "password": "Password",
            "port": "Porta",
            "save": "Guardar",
            "sites": "Casas de Apostas",
            "sitesPlaceholder": "Não selecionado",
            "type": "Tipo"
        },
        "columns": {
            "abnCount": "#ABN",
            "abnPerc": "ABN%",
            "accountCount": "A/C",
            "betCount": "#Apostas",
            "bookmakers": "Casas de Apostas",
            "connectTime": "Tempo de conexão",
            "hostname": "Hostname",
            "isActive": "Ativo",
            "isAgent": "Agente",
            "lastCheck": "Última verificação",
            "login": "Login",
            "name": "Nome",
            "totalTime": "Tempo total",
            "type": "Tipo"
        },
        "filters": {
            "proxyAvailable": "Disponibilidade",
            "proxyAvailableAvailable": "Disponível",
            "proxyAvailableDeleted": "Eliminado",
            "proxyBookmakerId": "Casas de Apostas",
            "proxySearch": "Pesquisar",
            "proxyStatus": "Estado",
            "proxyStatusActive": "Ativo",
            "proxyStatusInactive": "Inativo"
        }
    },
    "accounts": {
        "actions": {
            "copy": "Copiar para nova conta",
            "delete": "Eliminar conta",
            "edit": "Editar conta",
            "info": "Informações da conta",
            "relogin": "Relogar conta"
        },
        "bulk": {
            "active": "Ativo",
            "confirmActive": "Definir {count} conta(s) selecionada(s) como ativa(s)?",
            "confirmDelete": "Eliminar {count} conta(s) selecionada(s)?",
            "confirmDisable": "Desativar {count} conta(s) selecionada(s)?",
            "confirmInactive": "Definir {count} conta(s) selecionada(s) como inativa(s)?",
            "confirmRelogin": "Relogar {count} conta(s) selecionada(s)?",
            "delete": "Eliminar",
            "disable": "Desativar",
            "inactive": "Inativo",
            "relogin": "Relogar"
        },
        "columns": {
            "active": "Ativo",
            "bets": "Apostas",
            "botAbbr": "B",
            "browser": "Browser",
            "credit": "Crédito",
            "currency": "C",
            "date": "Data",
            "disabled": "Desativado",
            "login": "Login",
            "orderAbbr": "O",
            "parse": "Parse",
            "proxy": "Proxy",
            "set": "Conjunto",
            "sinceLastBet": "Desde última aposta",
            "status": "Estado",
            "user": "Utilizador",
            "validPerc": "Vld%"
        },
        "confirmDelete": "Eliminar esta conta?",
        "confirmRelogin": "Relogar esta conta?",
        "params": {
            "columns": {
                "param": "Param",
                "value": "Valor"
            },
            "alreadyExists": "Já existe um param com este nome para esta conta.",
            "paramRequired": "O param é obrigatório.",
            "paramMaxLength": "O param não pode ter mais de {max} caracteres.",
            "valueRequired": "O valor é obrigatório.",
            "valueMaxLength": "O valor não pode ter mais de {max} caracteres.",
            "confirmDelete": "Eliminar este param?",
            "editHint": "Duplo clique para editar",
            "editHintMobile": "Toque para editar",
            "filters": {
                "accountId": "Conta"
            },
            "form": {
                "createTitle": "Novo param"
            },
            "loadError": "Não foi possível carregar os params.",
            "noData": "Sem params."
        },
        "deleted": "Conta eliminada.",
        "filters": {
            "accountBookmakerId": "Casa de apostas",
            "accountSearch": "Pesquisar",
            "accountStatus": "Estado",
            "accountStatusActive": "Ativo",
            "accountStatusAll": "Todas as contas",
            "accountStatusDeleted": "Eliminado",
            "accountToolUserId": "Jogador"
        },
        "form": {
            "addPlayer": "Adicionar jogador",
            "apiKey": "Chave API",
            "browser": "Browser",
            "commissionBot": "Comissão bot",
            "commissionOrder": "Comissão ordem",
            "createTitle": "Nova conta",
            "created": "Conta criada.",
            "currency": "Moeda",
            "currencyPlaceholder": "Selecionar moeda",
            "editTitle": "Editar conta",
            "emulate": "Emular",
            "isActive": "Ativo",
            "isDisable": "Desativado",
            "login": "Login",
            "loginPredefined": "Novo login",
            "name": "Nome",
            "password": "Palavra-passe",
            "platformBot": "Bot",
            "platformOrder": "Ordem",
            "positionPerc": "Posição %",
            "proxy": "Proxy",
            "proxyPlaceholder": "Não utilizado",
            "proxyPool": "Pool de proxies",
            "proxyPoolPlaceholder": "Sem proxies selecionados",
            "save": "Guardar",
            "saved": "Conta atualizada.",
            "stateDisabled": "Desativado",
            "stateEnabled": "Ativo",
            "toolUsers": "Utilizadores da ferramenta",
            "usedForParser": "Usar para parse",
            "userSearchPlaceholder": "Pesquisar jogador (mín. 3 caracteres)",
            "validPerc": "Válido %"
        },
        "id": "ID",
        "login": "Login",
        "name": "Nome",
        "stats": {
            "accounts": "Contas",
            "disabled": "Desativadas",
            "loggedIn": "Com sessão",
            "loggedOut": "Sem sessão",
            "loggingIn": "A iniciar sessão"
        }
    },
    "action": {
        "add": "Adicionar",
        "apply": "Aplicar",
        "cancel": "Cancelar",
        "cancelOrder": "Cancelar Ordem",
        "close": "Fechar",
        "closeWindow": "Fechar Janela",
        "confirm": "Confirmar",
        "copy": "Cópia de",
        "delete": "Deletar",
        "deleteText": "Tem certeza de que deseja excluir este item?",
        "edit": "Editar",
        "export": "Exportar",
        "newOrder": "Nova Ordem",
        "no": "Não",
        "ok": "OK",
        "refresh": "Atualizar",
        "reload": "Recarregar",
        "reset": "Redefinir",
        "save": "GUARDAR",
        "updated": "Última edição",
        "yes": "Sim"
    },
    "pwa": {
        "newVersionAvailable": "Nova versão disponível"
    },
    "alerts": {
        "account": "Conta",
        "alert": "Alerta",
        "alertDateFilter": "Data do alerta",
        "alertType": "Tipo de Alerta",
        "allAlerts": "Todos os alertas",
        "book": "Casa",
        "date": "Data",
        "dismiss": "Dispensar",
        "dm": "DM",
        "dmTooltip": "Dispensado",
        "errorMessage": "Mensagem de erro",
        "game": "JOGO",
        "user": "Usuário"
    },
    "transfer": {
        "approvedByFilter": "Aprovado por",
        "confirmDelete": "Excluir esta transferência?",
        "currencyFilter": "Todas as moedas",
        "delete": "Excluir",
        "form": {
            "amount": "Valor ({symbol})",
            "createTitle": "Adicionar transferência",
            "description": "Descrição",
            "editTitle": "Editar transferência",
            "method": "Método",
            "operation": "Operação",
            "save": "Salvar",
            "status": "Status",
            "user": "Usuário"
        },
        "methodFilter": "Método",
        "operationFilter": "Operação",
        "statusFilter": "Status",
        "title": "Depósitos e Saques",
        "userFilter": "Usuário",
        "withdrawLimit": "Não é possível sacar mais do que o saldo disponível",
        "columns": {
            "agent": "Agente",
            "amount": "Valor",
            "approvedBy": "Aprovado por",
            "currency": "Moeda",
            "date": "Data",
            "method": "Método",
            "operation": "Operação",
            "status": "Status",
            "user": "Usuário"
        }
    },
    "notifications": {
        "all": "Todos",
        "confirmDelete": "Excluir esta notificação?",
        "countryFilter": "Todos os países",
        "createdByFilter": "Criado por",
        "dateFilter": "Data",
        "delete": "Excluir",
        "form": {
            "active": "Ativo",
            "allCountries": "Todos os países",
            "allPlatforms": "Todas as plataformas",
            "allRecipients": "Todos os destinatários",
            "country": "País",
            "createTitle": "Adicionar notificação",
            "editTitle": "Editar notificação",
            "platform": "Plataforma",
            "recipients": "Destinatários",
            "save": "Guardar",
            "textEn": "EN",
            "textPt": "PT",
            "type": "Tipo"
        },
        "idFilter": "ID da notificação",
        "platformFilter": "Todas as plataformas",
        "recipientFilter": "Jogador",
        "title": "Notificações",
        "typeFilter": "Todas as notificações",
        "types": {
            "error": "Erro",
            "info": "Info",
            "message": "Mensagem",
            "warning": "Aviso"
        },
        "columns": {
            "active": "Ativo",
            "countries": "Países",
            "createdBy": "Criado por",
            "date": "Data",
            "dismiss": "Dispensar",
            "platform": "Plataforma",
            "recipients": "Destinatários",
            "textEn": "Notificação EN",
            "textPt": "Notificação PT",
            "type": "Tipo"
        }
    },
    "currencyExchange": {
        "columns": {
            "date": "Data",
            "eurToCny": "EUR to CNY",
            "eurToUsd": "EUR to USD",
            "eurToGbp": "EUR to GBP",
            "eurToBrl": "EUR to BRL",
            "eurToHkd": "EUR to HKD",
            "eurToMyr": "EUR to MYR",
            "gbpToBrl": "GBP to BRL",
            "cnyToUsd": "CNY to USD",
            "cnyToBrl": "CNY to BRL",
            "cnyToMyr": "CNY to MYR",
            "cnyToHkd": "CNY to HKD",
            "usdToBrl": "USD to BRL",
            "usdToGbp": "USD to GBP",
            "usdToHkd": "USD to HKD",
            "usdToMyr": "USD to MYR",
            "hkdToBrl": "HKD to BRL",
            "hkdToMyr": "HKD to MYR",
            "myrToBrl": "MYR to BRL"
        },
        "form": {
            "createTitle": "Editar Taxas de Câmbio",
            "save": "Guardar",
            "eurToCny": "EUR to CNY rate",
            "eurToUsd": "EUR to USD rate",
            "eurToGbp": "EUR to GBP rate",
            "eurToBrl": "EUR to BRL rate",
            "eurToHkd": "EUR to HKD rate",
            "eurToMyr": "EUR to MYR rate",
            "gbpToBrl": "GBP to BRL rate",
            "cnyToUsd": "CNY to USD rate",
            "cnyToBrl": "CNY to BRL rate",
            "cnyToMyr": "CNY to MYR rate",
            "cnyToHkd": "CNY to HKD rate",
            "usdToBrl": "USD to BRL rate",
            "usdToGbp": "USD to GBP rate",
            "usdToHkd": "USD to HKD rate",
            "usdToMyr": "USD to MYR rate",
            "hkdToBrl": "HKD to BRL rate",
            "hkdToMyr": "HKD to MYR rate",
            "myrToBrl": "MYR to BRL rate"
        }
    },
    "appAlerts": {
        "alertCode": "Código do Alerta",
        "alertData": "Dados do Alerta",
        "alertDateFilter": "Data do alerta",
        "alertType": "Todos os Alertas",
        "check": "Check",
        "checkTooltip": "Investigar",
        "code": "Código",
        "comment": "Comentário",
        "confirmDelete": "Tem certeza de que deseja excluir os alertas selecionados?",
        "confirmDismiss": "Tem certeza de que deseja dispensar os alertas selecionados?",
        "count": "#",
        "dataLoadError": "Falha ao carregar dados do alerta",
        "date": "Data",
        "delete": "Excluir",
        "dism": "DISM",
        "dismTooltip": "Dispensado",
        "dismiss": "Dispensar",
        "dismissed": "Não Dispensado",
        "dismissedOption": "Dispensado",
        "investigate": "Todos",
        "more": "Mais",
        "notDismissed": "Não Dispensado",
        "notInvestigate": "Não investigar",
        "priority": "Todas as Prioridades",
        "priorityCritical": "Crítico",
        "priorityHigh": "Alto",
        "priorityLow": "Baixo",
        "text": "Texto",
        "typeInfo": "Info",
        "typeProblem": "Problema",
        "typeSingle": "Único",
        "user": "Usuário"
    },
    "bets": {
        "NC": "N/C",
        "account": "Conta",
        "actions": "Ações",
        "activityType": {
            "allBets": "Todas as Apostas",
            "betsDone": "Apostas executadas",
            "betsFailed": "Apostas perdidas",
            "title": "Tipo de Atividade"
        },
        "agent": "Agente",
        "agentBalance": "Saldo AG",
        "agentPt": "AG PT",
        "agentStake": "AG Stake",
        "agentTotal": "Total do Agente",
        "allBetTypes": "Todos os Tipos de Aposta",
        "allBookmakers": "Todos os Bookmakers",
        "allPlatforms": "Todas as Plataformas",
        "allStatus": "Todos os Status",
        "balance": "Saldo",
        "bet": "Aposta",
        "betDateFilter": "Data da aposta",
        "betDateType": "Tipo de Data",
        "betId": "ID da Aposta",
        "betSearch": "Buscar Aposta",
        "betType": "Tipo de Aposta",
        "export": "Exportar Apostas",
        "betVsClose": "Bet vs Fechamento",
        "betVsOpen": "Bet vs Abertura",
        "bets": "Apostas",
        "betsWithMissingStake": "Apostas com stake faltante",
        "betHasPositionPlatformRule": "Apostas com regra de plataforma",
        "betHasPositionUserRule": "Apostas com regras de utilizador",
        "book": "Casa",
        "bookBalance": "Saldo Casa",
        "bookStake": "B Stake",
        "bookmaker": "Todos os Bookmakers",
        "bot": "Bot",
        "botOrder": "Bot / Pedido",
        "closeOdds": "Odds de fechamento",
        "coOdds": "CO Odds",
        "commission": "Comm",
        "companyBalance": "Saldo CO",
        "companyPl": "P/L CO",
        "cornersNotConfirmed": "Escanteios não confirmados",
        "customer": "Cliente",
        "customerBalance": "Saldo do Cliente",
        "date": "Data",
        "editBet": {
            "betResult": "Resultado da Aposta",
            "betStatus": "Status da Aposta",
            "bookmaker": "Casa",
            "errors": {
                "invalidStatusChange": "O novo status da aposta não é válido",
                "resultRequired": "O resultado da aposta é obrigatório quando o status é Decidida"
            },
            "player": "Jogador",
            "title": "Definir Status/Saldo da Aposta"
        },
        "error": {
            "checkBets": "Algo deu errado, verifique as apostas"
        },
        "errorName": "Nome do Erro",
        "ftScore": "Placar FT",
        "game": "Jogo",
        "info": {
            "fields": {
                "account": "Conta",
                "accountValid": "Conta Válida",
                "activatedAt": "Ativado Em",
                "age": "Idade",
                "agent": "Agente",
                "agentPosition": "Posição do Agente",
                "agentPositionRequired": "Posição do Agente Obrigatória",
                "attackSupremacy": "Supremacia de ataque",
                "attacks": "Ataques",
                "awayTeam": "Time Visitante",
                "balance": "Saldo",
                "bet": "Aposta",
                "betAtHalfTime": "Aposta no Intervalo",
                "betDate": "Data da Aposta",
                "betId": "ID da Aposta",
                "betRepetition": "Repetição da aposta",
                "betSelection": "Seleção da aposta",
                "betType": "Tipo de Aposta",
                "betVsClose": "Bet vs Fechamento",
                "betVsOpen": "Bet vs Abertura",
                "bookmaker": "Casa de Apostas",
                "bookmakerBalance": "Saldo da Casa",
                "bookmakerBetId": "ID da Aposta na Casa",
                "bookmakerOdds": "Odds da Casa",
                "bookmakerStakeReal": "Stake da Casa (real)",
                "bookmakerStakeValid": "Stake da Casa (válido)",
                "botId": "ID do Bot",
                "botName": "Nome",
                "botStake": "Stake do Bot",
                "category": "Categoria",
                "closeOdds": "Odds de fechamento",
                "closingGoalLine": "Linha de gols de fechamento",
                "closingHandicap": "Handicap de fechamento",
                "companyPl": "P/L da Empresa",
                "companyPositionBalance": "Saldo da Posição da Empresa",
                "corners": "Escanteios",
                "cornersFt": "Escanteios FT",
                "cornersHt": "Escanteios HT",
                "cornersSupremacy": "Supremacia de escanteios",
                "dangerousAttackSupremacy": "Supremacia de ataque perigoso",
                "dangerousAttacks": "Ataques Perigosos",
                "date": "Data",
                "description": "Descrição",
                "deviceType": "Tipo de Dispositivo",
                "eventDate": "Data do Evento",
                "exchange": "Câmbio",
                "exchangeRate": "Taxa de Câmbio",
                "excludedLeagues": "Ligas Excluídas",
                "includedLeagues": "Ligas Incluídas",
                "extraFee": "Taxa Extra",
                "favoriteUnderdog": "Favorito/Underdog",
                "gender": "Gênero",
                "goalHandicap": "Handicap de gols",
                "goalLine": "Linha de Gols",
                "grossBookmaker": "Bruto (Casa)",
                "handicap": "Handicap",
                "homeTeam": "Time da Casa",
                "jollyWinPerc": "Jolly Win %",
                "jollywhere": "Jollywhere",
                "league": "Liga | Ligas",
                "limitsCategory": "Categoria de limites",
                "market": "Mercado",
                "marketMargin": "Margem do Mercado",
                "marketType": "Tipo de Mercado",
                "maxStakeValid": "Stake Máximo (válido)",
                "minute": "Minuto",
                "missingStake": "Stake Faltante",
                "odds": "Odds",
                "openOdds": "Odds de abertura",
                "openingGoalLine": "Linha de gols de abertura",
                "openingHandicap": "Handicap de abertura",
                "order": "Pedido",
                "orderStake": "Stake do Pedido",
                "period": "Período",
                "playerStake": "Stake do Jogador",
                "position": "Posição",
                "positionRequired": "Posição Obrigatória",
                "positionPlatformRule": "Regra de Posição da Plataforma",
                "positionUserRule": "Regra de Posição do Utilizador",
                "possession": "Posse de Bola %",
                "redCard": "Cartão Vermelho",
                "redCards": "Cartões Vermelhos",
                "result": "Resultado",
                "score": "Placar",
                "scoreFt": "Placar FT",
                "scoreHt": "Placar HT",
                "scoreSum": "Soma do Placar",
                "shots": "Chutes",
                "shotsOnTargetSupremacy": "Supremacia de chutes no gol",
                "shotsSupremacy": "Supremacia de chutes",
                "situation": "Situação",
                "skipBetfairOnly": "Pular Apenas Betfair",
                "stake": "Stake",
                "status": "Status",
                "topUps": "Top UPS",
                "totalAttack": "Total de ataques",
                "totalCorners": "Total de escanteios",
                "totalDangerousAttack": "Total de ataques perigosos",
                "totalShots": "Total de chutes",
                "totalShotsOnTarget": "Total de chutes no gol",
                "updatedAt": "Atualizado Em",
                "useMinStake": "Usar Stake Mínimo",
                "user": "Usuário",
                "wlBetId": "ID da Aposta WL"
            },
            "sections": {
                "balance": "Saldo",
                "betInformation": "Informações da Aposta",
                "botConditions": "Condições do Bot",
                "commission": "Comissão",
                "history": "Histórico",
                "liveStats": "Estatísticas ao Vivo"
            },
            "subsections": {
                "competition": "Competição",
                "liveConditions": "Condições ao Vivo",
                "liveStatsConditions": "Condições de Estatísticas ao Vivo",
                "marketMarginConditions": "Condições de Margem de Mercado",
                "pregameConditions": "Condições Pré-Jogo"
            },
            "title": "Detalhes da Aposta"
        },
        "league": "Liga",
        "log": {
            "error": "Falha ao carregar log da aposta",
            "showFormatted": "Mostrar visualização inicial",
            "showJson": "Mostrar visualização JSON",
            "title": "Log da Aposta"
        },
        "market": "Mercado",
        "marketType": "MT",
        "message": "Mensagem",
        "missingStake": "Stake M",
        "odds": "Odds",
        "openBets": "Apostas em aberto",
        "openOdds": "Odds de abertura",
        "orderId": "ID do Pedido",
        "payCommission": "Comissão Paga",
        "period": "M",
        "periodType": "Tipo de Período",
        "periodTypeShort": "PT",
        "plOdds": "PL Odds",
        "placementGmt": "Placement GMT",
        "placementLondon": "Placement London",
        "platform": "Plataforma",
        "player": "Jogador",
        "playerBalance": "Saldo PL",
        "position": "Posição",
        "pt": "PT",
        "ref": "Ref",
        "refund": {
            "confirm": "Reembolsar",
            "message": "Tem certeza que deseja reembolsar esta aposta?",
            "messagePlural": "Tem certeza que deseja reembolsar estas apostas?",
            "title": "Reembolsar aposta"
        },
        "result": "Resultado",
        "resultUsingScore": {
            "infoAuto": "Cada aposta será liquidada usando o seu próprio placar final.",
            "infoManual": "O placar \"{score}\" será aplicado a todas as {total} aposta(s) selecionada(s).",
            "infoSkipped": "{count} aposta(s) não têm placar final e serão ignoradas. O resultado será definido para {applied} de {total}.",
            "invalidFormat": "Formato de placar inválido. Exemplo: 2-1 (máx. 999-999)",
            "mismatchWarning": "O placar inserido difere do placar do evento para {count} de {total} aposta(s).",
            "noScore": "Não há placar final, não é possível definir o resultado.",
            "note": "Nota: o resultado da aposta será redefinido para a casa de apostas e para o jogador.",
            "placementError": "O placar final não pode ser menor que o placar no momento em que a aposta foi feita. Corrija o placar para continuar.",
            "scoreLabel": "Placar final",
            "title": "Definir resultado da aposta usando o placar"
        },
        "score": "Placar",
        "scoreNotConfirmed": "Placar não confirmado",
        "setResult": {
            "message": "Tem certeza que deseja definir o resultado \"{result}\" para a aposta selecionada?",
            "messagePlural": "Tem certeza que deseja definir o resultado \"{result}\" para as apostas selecionadas?",
            "setHL": "Definir resultado \"HL\"",
            "setHW": "Definir resultado \"HW\"",
            "setL": "Definir resultado \"L\"",
            "setP": "Definir resultado \"P\"",
            "setW": "Definir resultado \"W\"",
            "statusMessage": "Tem certeza que deseja definir um novo status/resultado para a aposta selecionada?",
            "unset": "Remover resultado da aposta",
            "unsetMessage": "Tem certeza que deseja remover o resultado da aposta selecionada?",
            "unsetMessagePlural": "Tem certeza que deseja remover o resultado das apostas selecionadas?"
        },
        "settlementGmt": "Settlement GMT",
        "settlementLondon": "Settlement London",
        "skipAutomaticSettlement": {
            "message": "Tem certeza que deseja pular a liquidação automática para a aposta selecionada?",
            "messagePlural": "Tem certeza que deseja pular a liquidação automática para as apostas selecionadas?",
            "title": "Pular liquidação automática"
        },
        "stake": "Stake",
        "status": "Status",
        "statusWarning": {
            "manuallySetBookmaker": "Resultado do bookmaker definido manualmente",
            "manuallySetPlayer": "Resultado do jogador definido manualmente"
        },
        "title": "Apostas",
        "toolUserObserve": {
            "excludeIrregular": "Excluir Irregular",
            "irregular": "Usuários Irregulares",
            "watched": "Usuários Observados"
        },
        "tooltips": {
            "agentBalanceTooltip": "Saldo do Agente",
            "agentPtTooltip": "Posição do Agente",
            "agentStakeTooltip": "Stake do Agente",
            "agentTotalTooltip": "Total do Agente",
            "betInfoTooltip": "Detalhes da Aposta",
            "betLogTooltip": "Ver Log da Aposta",
            "betVsCloseTooltip": "PL Odds menos Odds de fechamento",
            "betVsOpenTooltip": "PL Odds menos Odds de abertura",
            "bookBalanceTooltip": "Saldo da Casa",
            "bookStakeTooltip": "Stake da Casa",
            "bookTooltip": "Casa de Apostas",
            "closeOddsTooltip": "Odds de fechamento",
            "coOddsTooltip": "Odds da Empresa",
            "commissionTooltip": "Comissão Bruta",
            "companyBalanceTooltip": "Saldo da Empresa",
            "companyPlTooltip": "P/L da Empresa",
            "customerBalanceTooltip": "Saldo do Cliente",
            "marketTypeTooltip": "Tipo de Mercado",
            "missingStakeTooltip": "Stake Faltante",
            "openOddsTooltip": "Odds de abertura",
            "payCommissionTooltip": "Comissão Paga",
            "periodTooltip": "Período do Evento (FT/1H)",
            "plOddsTooltip": "Odds do Jogador",
            "playerBalanceTooltip": "Saldo do Jogador",
            "ptTooltip": "Posição da Empresa",
            "refundTooltip": "Reembolsar Aposta",
            "scoreTooltip": "Placar",
            "stakeTooltip": "Stake do Jogador",
            "topupTooltip": "Top up",
            "viewWlTransactions": "Ver Transações WL",
            "viewBetSettlement": "Ver Liquidação de Apostas"
        },
        "topup": "Tup",
        "tradingType": "Trading Type",
        "user": "Usuário",
        "userObserveId": "Todos os Usuários",
        "void": {
            "confirm": "Anular",
            "message": "Tem certeza que deseja anular esta aposta?",
            "messagePlural": "Tem certeza que deseja anular estas apostas?",
            "title": "Anular aposta"
        }
    },
    "bookBalance": {
        "agBalance": "Saldo AG",
        "agTurnover": "Volume AG",
        "betCount": "#Apostas",
        "betDateFilter": "Data da aposta",
        "bookBalance": "Saldo Book",
        "bookComm": "Comissão Book",
        "bookFees": "Taxas Book",
        "bookStaked": "Apostado Book",
        "bookTotal": "Total Book",
        "bookTurnover": "Volume Book",
        "bookmaker": "Bookmaker",
        "brlPlayersAccounts": "Contas de Jogadores Real Brasileiro(R$)",
        "coPositionBalance": "Saldo Posição CO",
        "companyPL": "P/L Empresa",
        "datePeriod": {
            "currentMonth": "Mês Atual",
            "currentWeek": "Semana Atual",
            "currentYear": "Ano Atual",
            "lastMonth": "Mês Passado",
            "lastWeek": "Semana Passada",
            "range": "Período de Data",
            "title": "Período de Data",
            "today": "Hoje",
            "yesterday": "Ontem"
        },
        "euroPlayersAccounts": "Contas de Jogadores Euro(€)",
        "feesRebate": "Reembolso Taxas",
        "gbpPlayersAccounts": "Contas de Jogadores GBP(£)",
        "payComms": "Comissões Pagas",
        "playerBalance": "Saldo Jogador",
        "playerYield": "Rendimento Jogador",
        "position": "Posição",
        "staked": "Apostado",
        "totalEuro": "TOTAL Euro(€)",
        "turnover": "Volume",
        "usdPlayersAccounts": "Contas de Jogadores USD($)"
    },
    "userBalance": {
        "agPayComms": "AG Pay Comms",
        "agTotal": "AG Total",
        "balance": "Saldo",
        "bookRebate": "Book Rebate",
        "bots": "#Bots",
        "comms": "Comms",
        "company": "Company",
        "pl": "P/L",
        "ptBalance": "PT Balance",
        "role": "Função",
        "user": "Usuário"
    },
    "report": {
        "agentBalance": "Saldo Agente",
        "agentComm": "Comm Agente",
        "agentPl": "P/L Agente",
        "agentStaked": "Apostado Agente",
        "commTurnover": "Comm Turnover",
        "customer": "Cliente",
        "customerBalance": "Saldo Cliente",
        "customerYield": "Rendimento Cliente",
        "totalAgent": "Total Agente"
    },
    "bookmaker": {
        "active": "ATIVO",
        "betting": "Apostas",
        "bettingError": "Erro de Apostas",
        "code": "Código",
        "confirmActivate": "Tem certeza de que deseja ativar a casa de apostas {name}?",
        "confirmDeactivate": "Tem certeza de que deseja desativar a casa de apostas {name}?",
        "confirmRunBetting": "Tem certeza de que deseja adicionar {name} aos feeds e executar as apostas de {name}?",
        "confirmStopBetting": "Tem certeza de que deseja excluir {name} dos feeds e parar as apostas de {name}?",
        "confirmStopBettingAll": "Tem certeza de que deseja parar as apostas para TODAS as casas de apostas?",
        "maintenance": "Manutenção",
        "name": "Nome",
        "run": "Executar",
        "stop": "Parar",
        "stopBettingAll": "PARAR APOSTAS",
        "title": "Casas de Apostas",
        "url": "Url",
        "params": {
            "columns": {
                "param": "Param",
                "value": "Valor"
            },
            "alreadyExists": "Já existe um param com este nome para este site.",
            "paramRequired": "O param é obrigatório.",
            "paramMaxLength": "O param não pode ter mais de {max} caracteres.",
            "valueRequired": "O valor é obrigatório.",
            "valueMaxLength": "O valor não pode ter mais de {max} caracteres.",
            "confirmDelete": "Eliminar este param?",
            "editHint": "Duplo clique para editar",
            "editHintMobile": "Toque para editar",
            "form": {
                "createTitle": "Novo param"
            },
            "loadError": "Não foi possível carregar os params.",
            "noData": "Sem params."
        }
    },
    "bots": {
        "columns": {
            "balance": "Saldo",
            "bets": "Apostas",
            "created": "Criado",
            "id": "ID",
            "lastActivity": "Última atividade",
            "market": "M",
            "name": "Bot",
            "status": "Status",
            "turnover": "Volume",
            "user": "Usuário"
        },
        "detailsTitle": "Detalhes do Bot",
        "info": {
            "marginTo": "até {value}%",
            "minStake": "Mín"
        },
        "filters": {
            "botId": "ID do Bot",
            "market": "Mercado",
            "name": "Nome",
            "status": "Status",
            "statusActive": "Ativo",
            "statusInactive": "Inativo"
        },
        "status": {
            "active": "Ativo",
            "inactive": "Inativo"
        }
    },
    "common": {
        "1X2": "1X2",
        "actions": "Ações",
        "details": "Detalhes",
        "markets": "Mercados",
        "referenceIds": "IDs de Referência",
        "allBookmakers": "Tudo Bookmakers",
        "allBots": "Tudo Bots",
        "allItems": "Todos os itens",
        "alreadyExistLeague": "Não foi possível adicionar. Liga com este nome já anexado",
        "alreadyExists": "Não foi possível {operation} esta {table}. {table} com este {uniqColumnNames} já existe",
        "asianHandicap": "Handicap Asiático",
        "away": "Fora",
        "betSource": "Origem da Aposta",
        "betStatus": "Status da Aposta",
        "betType": "Tipo de Aposta",
        "bookmakers": "Bookmaker | Bookmakers",
        "boolean": "O campo {attribute} deve ser verdadeiro ou falso",
        "bots": "Bot | Bots",
        "bts": "AEM",
        "btsAbbr": "AEM",
        "btts": "Ambas Equipes Marcam",
        "clearHistory": "Limpar histórico",
        "copiedToClipboard": "Copiado para a área de transferência",
        "cornersAsianHandicap": "Escanteios Handicap Asiático",
        "cornersAway": "Escanteios Fora",
        "cornersGoal": "Total Asiático de Escanteios",
        "cornersGoalAbbr": "E-O/U",
        "cornersHandicapAbbr": "E-A/H",
        "cornersHome": "Escanteios Casa",
        "cornersOver": "Escanteios Mais",
        "cornersUnder": "Escanteios Menos",
        "correctScore": "Placar Exato",
        "csAbbr": "CS",
        "date": "Data",
        "dc": "DC",
        "dcAbbr": "DC",
        "deletedCountNotSuccess": "{countSuccess} registro(s) foram excluídos com sucesso. {countNotSuccess} registro(s) não foram excluídas",
        "deletedCountSuccess": "{countSuccess} registro(s) foram excluídos com sucesso",
        "displayedCurrency": "Moeda de Exibição",
        "doubleChance": "Chance Dupla",
        "draw": "Empate",
        "error": "Ocorreu um erro. Por favor, tente novamente mais tarde",
        "errorDeleted": "O registro não foi removido",
        "eventDate": "Game Date",
        "eventId": "ID do Evento",
        "eventType": "Tipo de Evento",
        "exists": "O {attribute} selecionado é inválido",
        "favorite": "Favorito",
        "filters": "Filtros",
        "goal": "Total de Gols Asiático",
        "goalAbbr": "O/U",
        "handicap": "Handicap Asiático",
        "handicapAbbr": "A/H",
        "hiddenFilters": "Filtros",
        "home": "Casa",
        "in": "O {attribute} selecionado é inválido",
        "integer": "O {attribute} deve ser um número inteiro",
        "imagePath": "Nome da Imagem",
        "item": "Item | Itens",
        "json": "O {attribute} deve ser uma string JSON válida",
        "kickOff": "Início",
        "live": "Ao Vivo",
        "loading": "Carregando...",
        "maintenance": "Este site está passando por manutenção programada no momento. Devemos voltar em breve.",
        "market": "Mercado",
        "marketType": "Tipo de Mercado (PG/LV)",
        "market1H": "1º Tempo",
        "marketDball": "Pré-jogo",
        "marketDballShort": "PG",
        "marketFT": "Tempo Inteiro",
        "marketLive": "Ao Vivo",
        "marketLiveShort": "LV",
        "max": {
            "array": "O {attribute} não pode ter mais de {max} itens",
            "file": "O {attribute} não pode ser maior que {max} kilobytes",
            "numeric": "O {attribute} não pode ser maior que {max}",
            "string": "O {attribute} não pode ser maior que {max} caracteres"
        },
        "min": {
            "array": "O {attribute} deve ter pelo menos {min} itens",
            "file": "O {attribute} deve ter pelo menos {min} kilobytes",
            "numeric": "O {attribute} deve ser pelo menos {min}",
            "string": "O {attribute} deve ter pelo menos {min} caracteres"
        },
        "minThreeChars": "Digite pelo menos 3 caracteres",
        "month": "Mês",
        "no": "Não",
        "noBookmakers": "Bookmaker",
        "noBots": "Bot",
        "noDataAvailable": "Não há dados disponíveis",
        "noHiddenFilters": "Nenhum filtro oculto",
        "noItem": "Nenhum item",
        "noSettings": "Sem configurações disponíveis",
        "notExistLeague": "Não foi possível remover. Liga com este nome não está anexada",
        "notFound": "Não encontrado",
        "notIn": "O {attribute} selecionado é inválido",
        "notPermitted": "Operação não permitida",
        "numeric": "O {attribute} deve ser um número",
        "of": "de",
        "operationForbidden": "Não há permissão para acessar esta ação",
        "or": " ou ",
        "order": "Pedido",
        "over": "Mais",
        "period1H": "1º Tempo",
        "period1HAbbr": "1T",
        "periodFT": "Tempo Inteiro",
        "periodFTAbbr": "TI",
        "playerCurrency": "Moeda do Jogador",
        "pregame": "Pré-jogo",
        "recent": "Recentes",
        "regex": "O formato de {attribute} é inválido",
        "required": "O campo {attribute} é obrigatório",
        "requiredIf": "O campo {attribute} é obrigatório quando {other} é {value}",
        "requiredWith": "O campo {attribute} é obrigatório quando {values} está presente",
        "search": "Procurar",
        "selectAll": "Selecionar tudo",
        "show": "Mostrar",
        "showing": "Mostrando",
        "stake": "Aposta",
        "string": "O {attribute} deve ser uma string",
        "successAdded": "O registro foi adicionado com sucesso",
        "successDeleted": "O registro foi removido com sucesso",
        "successSent": "E-mail enviado com sucesso",
        "successUpdated": "O registro foi atualizado com sucesso",
        "team": "Equipe",
        "customTeam": "Equipe Personalizada",
        "customLeague": "Liga Personalizada",
        "today": "Hoje",
        "total": "Total",
        "tradingType": "Tipo de Trading",
        "under": "Menos",
        "underdog": "Underdog",
        "uniq": "O {attribute} já existe",
        "uploadFailed": "Algo deu errado, por favor contacte o suporte",
        "week": "Semana",
        "wrongParams": "Parâmetros de solicitação incorretos.",
        "yes": "Sim"
    },
    "customLeagues": {
        "actions": {
            "delete": "Excluir liga customizada",
            "edit": "Editar liga customizada"
        },
        "age": "Idade",
        "category": "Categoria",
        "confirmDelete": "Excluir esta liga customizada?",
        "country": "País",
        "fixing": "Fixing",
        "form": {
            "ageCategory": "Categoria de idade",
            "category": "Categoria",
            "country": "País",
            "createTitle": "Adicionar liga customizada",
            "editTitle": "Editar liga customizada",
            "fixing": "Fixing",
            "gender": "Gênero",
            "limitsCategory": "Categoria de limites",
            "marketCategory": "Categoria de mercado",
            "minute": "Minuto",
            "name": "Nome",
            "rank": "Rank",
            "save": "Salvar",
            "tier": "Tier",
            "wikiLink": "Link Wiki"
        },
        "gender": "Gênero",
        "limits": "Limites",
        "market": "Mercado",
        "minute": "Minuto",
        "name": "Nome",
        "sport": "Esporte",
        "tier": "TIER",
        "wiki": "Wiki"
    },
    "customTeam": {
        "actions": {
            "delete": "Excluir equipe customizada",
            "edit": "Editar equipe customizada"
        },
        "confirmDelete": "Excluir esta equipe customizada?",
        "countryName": "País",
        "createdAt": "Criado",
        "deletedAt": "Deletado",
        "fileUploadError": "Falha ao carregar o ficheiro.",
        "filters": {
            "countryId": "País",
            "customTeamIsWomen": "Feminino",
            "customTeamIsYouth": "Juvenil",
            "customTeamName": "Nome da Equipe Custom",
            "customTeamTypeId": "Tipo",
            "sportId": "Sport"
        },
        "form": {
            "country": "País",
            "createTitle": "Adicionar equipe customizada",
            "editTitle": "Editar equipe customizada",
            "name": "Nome",
            "save": "Salvar",
            "twitter": "Twitter",
            "type": "Tipo",
            "wikiLink": "Link Wiki",
            "women": "Feminino",
            "youth": "Juvenil"
        },
        "gameCount": "Qtd. Jogos",
        "id": "ID",
        "image": "Imagem",
        "imageEditHint": "Duplo clique para editar",
        "imageEditHintMobile": "Toque para editar",
        "imagePath": "O Nome da Imagem deve terminar com um dos seguintes: .png, .webp.",
        "imagePathNoExists": "O ficheiro de imagem não existe",
        "isImageChangedManually": "Imagem Manual",
        "isUseTradeball": "Tradeball",
        "logo": "Logo",
        "logoUploadFailed": "Falha ao carregar o ficheiro",
        "logoUploaded": "Ficheiro carregado com sucesso",
        "logoWebpConversionFailed": "Logo carregado, mas a conversão WebP falhou",
        "name": "Nome",
        "shortCode": "Código Curto",
        "sportId": "Sport",
        "twitter": "Twitter",
        "typeId": "Do Tipo",
        "updatedAt": "Atualizado",
        "uploadLogo": {
            "browse": "Procurar ficheiros",
            "divider": "ou",
            "dropTitle": "Arraste e solte o PNG aqui",
            "title": "Carregar Logo",
            "upload": "Carregar"
        },
        "wikiLink": "Wiki",
        "women": "Feminino",
        "youth": "Juvenil"
    },
    "eventExtra": {
        "error": "Falha ao carregar event extra",
        "title": "Event Extra"
    },
    "dark": {
        "off": "Modo escuro desativado",
        "on": "Modo escuro ativado"
    },
    "dictionaries": {
        "15s": "15s",
        "1X2": "1X2",
        "1min": "1 min",
        "30s": "30s",
        "5min": "5 min",
        "5s": "5s",
        "BTTS": "Ambas Equipes Marcam",
        "active": "Ativos",
        "allLines": "Todas as linhas",
        "awayTeam": "Fora",
        "betFailPlainError": {
            "bookmakerError": "Erro no bookmaker",
            "bookmakerFailedToExecute": "O bookmaker não executou a aposta",
            "creditLineError": "Erro de linha de crédito",
            "handicapChanged": "O handicap mudou",
            "insufficientCredit": "Saldo insuficiente",
            "oddsReduced": "As odds baixaram"
        },
        "betResult": {
            "hl": "½P",
            "hw": "½G",
            "l": "P",
            "p": "D",
            "w": "G"
        },
        "betResultFull": {
            "hl": "½ Perdida",
            "hw": "½ Ganha",
            "l": "Perdida",
            "p": "Devolvida",
            "w": "Ganha"
        },
        "betSelection": {
            "btsNo": "Não",
            "btsYes": "Sim",
            "cornersGoalOver": "Mais",
            "cornersGoalUnder": "Menos",
            "cornersHandicapAway": "Fora",
            "cornersHandicapHome": "Casa",
            "cs": "",
            "dc12": "Casa ou Fora",
            "dc1X": "Casa ou Empate",
            "dcX2": "Empate ou Fora",
            "drawNoBetAway": "Fora",
            "drawNoBetHome": "Casa",
            "goalAwayOver": "Mais",
            "goalAwayUnder": "Menos",
            "goalHomeOver": "Mais",
            "goalHomeUnder": "Menos",
            "goalOver": "Mais",
            "goalUnder": "Menos",
            "handicapAway": "Fora",
            "handicapHome": "Casa",
            "moneylineAway": "Fora",
            "moneylineHome": "Casa",
            "oneXTwoAway": "Fora",
            "oneXTwoDraw": "Empate",
            "oneXTwoHome": "Casa",
            "spreadAway": "Fora",
            "spreadHome": "Casa"
        },
        "betSelectionType": {
            "1X2": "1X2",
            "goal": "Total de Gols Asiático",
            "handicap": "Handicap Asiático"
        },
        "betStatus": {
            "abnormal": "Anormal",
            "refunded": "Reembolsada",
            "rejected": "Rejeitada",
            "running": "Em jogo",
            "settled": "Decidida",
            "void": "Nula",
            "waiting": "Em espera"
        },
        "bettingStatus": {
            "open": "Aberta",
            "settled": "Decidida"
        },
        "bot": "Apostas Bot",
        "botBetRepetition": {
            "oneBetPerEvent": "Apenas uma aposta por jogo",
            "oneBetPerEventScore": "Apenas uma aposta por jogo e resultado"
        },
        "botFavoriteSide": {
            "away": "Fora",
            "home": "Casa"
        },
        "botScoreSumCondition": {
            "equalTo": "Igual a",
            "greaterThan": "Maior que",
            "lessThan": "Menor que"
        },
        "botTeamSelection": {
            "away": "Fora",
            "favourite": "Favorito",
            "home": "Casa",
            "underdog": "Não favorito"
        },
        "clAgeCategory": {
            "kids": "Criança (U17 ou Menor)",
            "senior": "Adultos (Time Principal)",
            "youth": "Jovens (U18 a U23)"
        },
        "clCategory": {
            "clubFriendly": "Amistoso de Clubes",
            "clubInternational": "Competições Internacionais de Clubes",
            "domesticCup": "Copa Doméstica",
            "domesticLeague": "Liga Doméstica",
            "international": "Internacional de seleções",
            "internationalFriendly": "Amistosos de seleções"
        },
        "clLimits": {
            "high": "High",
            "low": "Low",
            "medium": "Medium",
            "micro": "Micro",
            "pro": "Pro"
        },
        "clMarketCategory": {
            "cfriEff": "CfriEff",
            "fanEff": "FanEff",
            "intEff": "IntEff",
            "kidEff": "KidEff",
            "lowEff": "LowEff",
            "medEff": "MedEff",
            "microEff": "MicroEff",
            "proEff": "ProEff",
            "youthEff": "YouthEff"
        },
        "closeReasonGameAccountBlocked": "Fechada",
        "closeReasonGameFinished": "Jogo Terminado",
        "closeReasonGameRejectedBet": "Rejeitada",
        "closeReasonGameStarted": "Jogo Iniciado",
        "closeReasonInsufficientCredit": "Crédito Insuficiente",
        "closeReasonManuallyClosed": "Fechada Manualmente",
        "closeReasonNormally": "Executada",
        "closeReasonScoreChanged": "Resultado Mudou",
        "closeReasonTimedOut": "Tempo Esgotado",
        "closed": "Fechada",
        "closing": "Fechando",
        "correctScore": "Placar Exato",
        "currency": {
            "brl": "BRL",
            "euro": "EUR",
            "gbp": "GBP",
            "hongKongDollar": "HKD",
            "malaysianRinggit": "MYR",
            "usd": "USD",
            "yen": "JPY"
        },
        "deviceType": {
            "mobile": "Mobile",
            "pc": "PC"
        },
        "documentType": {
            "id": "ID",
            "utility": "Utility"
        },
        "doubleChance": "Chance Dupla",
        "early": "Próximos dias",
        "earlyMarket": "Próximos dias",
        "english": "Inglês",
        "equalTo": "Igual a",
        "eventPeriod": {
            "period1H": "1a Parte",
            "period1HShort": "1T",
            "periodFT": "Tempo Inteiro",
            "periodFTShort": "TI"
        },
        "eventRedCards": {
            "away1ManUp": "Casa 1 cartão vermelho",
            "away2MenUp": "Casa 2 cartões vermelhos",
            "bothTeamsDownTo10Men": "Ambas as equipes com 10 jogadores",
            "home1ManUp": "Fora 1 cartão vermelho",
            "home2MenUp": "Fora 2 cartões vermelhos",
            "noRedCards": "Sem cartões vermelhos"
        },
        "eventSituation": {
            "awayLeading": "Fora vencendo",
            "awayLeadingBy1": "Fora ganhando por 1",
            "awayLeadingBy2": "Fora ganhando por 2",
            "awayLeadingBy3OrMore": "Fora ganhando por 3 ou mais",
            "draw": "Empatado",
            "favouriteLeading": "Favorito ganhando",
            "favouriteLeadingBy1": "Favorito ganhando por 1",
            "favouriteLeadingBy2": "Favorito ganhando por 2",
            "favouriteLeadingBy3OrMore": "Favorito ganhando por 3 ou mais",
            "homeLeading": "Casa vencendo",
            "homeLeadingBy1": "Casa ganhando por 1",
            "homeLeadingBy2": "Casa ganhando por 2",
            "homeLeadingBy3OrMore": "Casa ganhando por 3 ou mais",
            "noDraw": "Não empantado",
            "underdogLeading": "Favorito perdendo",
            "underdogLeadingBy1": "Favorito perdendo por 1",
            "underdogLeadingBy2": "Favorito perdendo por 2",
            "underdogLeadingBy3OrMore": "Favorito perdendo por 3 ou mais"
        },
        "eventType": {
            "live": "Ao Vivo",
            "pregame": "Pré-jogo"
        },
        "feedLine": {
            "all": "Todas as linhas",
            "five": "Cinco linhas",
            "four": "Quatro linhas",
            "main": "Linha principal",
            "three": "Três linhas",
            "two": "Duas linhas"
        },
        "fiveLines": "Cinco linhas",
        "fourLines": "Quatro linhas",
        "gameStatus": {
            "next1h": "Próximas 1h",
            "next2h": "Próximas 2h",
            "next4h": "Próximas 4h",
            "notStarted": "Não Iniciado",
            "todayGames": "Jogos de Hoje"
        },
        "gender": {
            "men": "Homens",
            "women": "Mulheres"
        },
        "goal": "Total de Gols Asiático",
        "greaterThan": "Maior que",
        "handicap": "Handicap Asiático",
        "homeTeam": "Casa",
        "inactive": "Inativos",
        "jollywhere": {
            "away": "Fora",
            "home": "Casa"
        },
        "lessThan": "Menor que",
        "mainLine": "Linha principal",
        "mappingProblemSolutionStatus": {
            "applied": "Aplicado",
            "proposed": "Proposto"
        },
        "mappingProblemStatus": {
            "awaitingData": "A aguardar dados",
            "open": "Aberto",
            "processing": "A processar",
            "resolvedAutomatic": "Resolvido (Automático)",
            "resolvedManual": "Resolvido (Manual)",
            "resolvedThirdParty": "Resolvido (Terceiros)"
        },
        "mappingProblemType": {
            "leagueMismatch": "Liga Errada",
            "sameTeamOnBothSides": "Mesma Equipa em Ambos Lados",
            "teamOpponentMismatch": "Equipa Oponente Errada",
            "teamsSwapped": "Equipas Trocadas"
        },
        "marketType": {
            "full": {
                "bts": "Ambas equipes marcam",
                "cornersGoal": "Total asiático de escanteios",
                "cornersHandicap": "Escanteios handicap asiático",
                "cs": "Placar exato",
                "dc": "Chance dupla",
                "drawNoBet": "Empate anula aposta",
                "goal": "Total de gols",
                "goalAway": "Gols Fora",
                "goalHome": "Gols Casa",
                "handicap": "Handicap asiático",
                "moneyline": "Moneyline",
                "oneXTwo": "1X2",
                "spread": "Spread"
            },
            "short": {
                "bts": "AEM",
                "cornersGoal": "C-O/U",
                "cornersHandicap": "C-A/H",
                "cs": "CS",
                "dc": "DC",
                "drawNoBet": "EAA",
                "goal": "O/U",
                "goalAway": "F-O/U",
                "goalHome": "C-O/U",
                "handicap": "A/H",
                "moneyline": "ML",
                "oneXTwo": "1X2",
                "spread": "Spread"
            }
        },
        "men": "Homens",
        "off": "OFF",
        "open": "Pendente",
        "order": "Ordens Manuais",
        "orderOddsType": {
            "bestOdds": "Melhores Odds",
            "lowestOdds": "Odds baixas",
            "medianOdds": "Odds médias"
        },
        "period1H": "1a Parte",
        "periodFT": "Tempo Inteiro",
        "platform": {
            "apostasbf": "Apostas BF",
            "apostasnow": "Apostasnow",
            "betbox": "Betbox",
            "betbra": "Betbra",
            "bolsadeaposta": "Bolsa de Aposta",
            "drinbet": "Drinbet",
            "fulltbet": "Fulltbet",
            "greenwin": "Greenwin",
            "matchbook": "Matchbook",
            "oddrs": "Oddrs",
            "oddjusta": "Oddjusta",
            "tradeball": "Tradeball",
            "verdinhabet": "VerdinhaBet"
        },
        "portuguese": "Português",
        "senior": "Adultos",
        "sport": {
            "basketball": "Basquete",
            "football": "Futebol"
        },
        "teamAge": {
            "senior": "Adultos",
            "youth": "Jovens"
        },
        "teamType": {
            "club": "Clube",
            "fantasy": "Fantasia",
            "national": "Nacional"
        },
        "threeLines": "Três linhas",
        "timeAutoRefresh": {
            "15s": "15s",
            "1min": "1 min",
            "30s": "30s",
            "5min": "5 mins",
            "5s": "5s",
            "off": "OFF"
        },
        "today": "Hoje",
        "todayMarket": "Hoje",
        "toolUserType": {
            "administrator": "Administrador",
            "agent": "Agente",
            "agentView": "Agente-visualização",
            "agentPlatform": "Agente-plataforma",
            "company": "Empresa",
            "player": "Jogador",
            "root": "Root"
        },
        "tradingType": {
            "betOrder": "Ordens Manuais",
            "bot": "Apostas Bot"
        },
        "twoLines": "Duas linhas",
        "transferOperation": {
            "deposit": "Depósito",
            "withdrawal": "Saque"
        },
        "auditAction": {
            "add": "Adicionar",
            "delete": "Excluir",
            "update": "Atualizar"
        },
        "transferStatus": {
            "approved": "Aprovado",
            "expired": "Expirado",
            "pending": "Pendente",
            "rejected": "Rejeitado"
        },
        "wlTransactionOperation": {
            "credit": "Crédito",
            "debit": "Débito",
            "info": "Info"
        },
        "wlTransactionStatus": {
            "failed": "Falhou",
            "manualClosed": "Fechado manualmente",
            "notProcessed": "Não processado",
            "processed": "Processado"
        },
        "wlTransactionType": {
            "acceptBet": "Aceitar aposta",
            "changeStatus": "Alterar status",
            "failedBet": "Aposta falhada",
            "newBet": "Nova aposta",
            "unsetBet": "Desfazer aposta"
        },
        "betSettlementType": {
            "new": "Novo",
            "update": "Atualizar"
        },
        "women": "Mulheres",
        "youth": "Jovens"
    },
    "entityDbRow": {
        "error": "Falha ao carregar linha do BD",
        "menuItem": "Obter linha do BD",
        "title": "Linha do BD"
    },
    "feedCustomEventExclude": {
        "successAdded": "Evento personalizado excluído de todos os bookmakers com sucesso",
        "successDeleted": "Evento personalizado incluído em todos os bookmakers com sucesso"
    },
    "feedEventExclude": {
        "successAdded": "Evento excluído dos feeds com sucesso",
        "successDeleted": "Evento incluído nos feeds com sucesso"
    },
    "filters": {
        "handicap": "Handicap",
        "handicapShort": "HDP"
    },
    "forgotPassword": {
        "email": "Email",
        "sendPasswordResetLink": "Enviar link de redefinição de senha"
    },
    "leagues": {
        "actions": {
            "delete": "Excluir liga"
        },
        "association": {
            "associate": "Associar",
            "bookmakerLeague": "Liga da casa",
            "title": "Associar liga personalizada"
        },
        "associationStatus": "Todas as ligas",
        "associationStatusAll": "Todas as ligas",
        "associationStatusAssociated": "Somente com associação",
        "associationStatusNotAssociated": "Somente sem associação",
        "bookmaker": "Todas as Casas",
        "bookmakerId": "ID da Casa",
        "confirmDelete": "Excluir esta liga?",
        "customLeague": "Liga Personalizada",
        "customLeagueNameId": "Nome da Liga Personalizada (id)",
        "gameCount": "#Jogos",
        "name": "Nome",
        "notAssociated": "Não associado",
        "sport": "Esporte"
    },
    "live": {
        "stats": {
            "attacks": "Ataques",
            "attacksShort": "A",
            "corners": "Escanteios",
            "cornersShort": "E",
            "dangerousAttacks": "Ataques Perigosos",
            "dangerousAttacksShort": "AP",
            "fouls": "Faltas",
            "foulsShort": "FS",
            "hitWoodwork": "Finalizações na Trave",
            "hitWoodworkShort": "T",
            "possession": "Posse %",
            "possessionShort": "P",
            "redCards": "Cartões Vermelhos",
            "redCardsShort": "V",
            "shots": "Finalizações",
            "shotsOnTarget": "Finalizações no Alvo",
            "shotsOnTargetShort": "FA",
            "shotsShort": "F",
            "yellowCards": "Cartões Amarelos",
            "yellowCardsShort": "A"
        },
        "timeScore": "Tempo"
    },
    "loggedPlayers": {
        "appId": "App ID",
        "betPopups": "Popups de apostas",
        "browser": "Navegador",
        "bulk": {
            "confirmLogout": "Terminar sessão de {count} jogador(es) selecionado(s)?",
            "confirmReloadMain": "Ir à página principal e recarregar para {count} jogador(es) selecionado(s)?",
            "confirmReloadTool": "Recarregar ferramenta para {count} jogador(es) selecionado(s)?",
            "logout": "Terminar sessão",
            "reloadMain": "Ir à página principal + Recarregar",
            "reloadTool": "Recarregar ferramenta"
        },
        "connectionId": "ID",
        "expanded": {
            "bettingPopup": {
                "betSelectionId": "Seleção de aposta",
                "correctScore": "Resultado exato",
                "customEventId": "Evento personalizado",
                "handicap": "Handicap",
                "isLive": "Ao vivo",
                "jollywhere": "Jollywhere",
                "marketId": "Mercado",
                "periodTypeId": "Tipo de período",
                "popupKey": "Chave",
                "score": "Resultado",
                "siteIds": "Sites",
                "uuid": "UUID"
            },
            "bettingPopupTitle": "Dados do popup de apostas",
            "eventPopup": {
                "customEventId": "Evento personalizado",
                "eventDate": "Data do evento",
                "tradingTypeId": "Tipo de trading"
            },
            "eventPopupTitle": "Dados do popup de evento",
            "markets": {
                "feedUniqData": "Dados únicos do feed",
                "feedVersion": "Versão do feed",
                "feedVersionPrev": "Versão anterior do feed",
                "filterCustomEventIds": "Eventos personalizados do filtro",
                "filterLine": "Linha do filtro",
                "filterMarketId": "Mercado do filtro",
                "filterPeriodTypeId": "Tipo de período do filtro",
                "filterTradingTypeId": "Tipo de trading do filtro",
                "marketKey": "Chave"
            },
            "marketsTitle": "Mercados"
        },
        "favEvents": "Eventos favoritos",
        "favoriteCustomEventIdsError": "Falha ao carregar IDs de eventos personalizados favoritos",
        "favoriteCustomEventIdsTitle": "IDs de eventos personalizados favoritos",
        "infoMenu": {
            "favoriteCustomEventIds": "IDs de eventos favoritos",
            "rowData": "Mostrar dados da linha"
        },
        "ip": "IP",
        "os": "SO",
        "pageCode": "Código da página",
        "pageUrl": "URL da página",
        "rowDataError": "Falha ao carregar dados da linha",
        "rowDataTitle": "Dados da linha",
        "scriptVersion": "Versão do script",
        "search": "Pesquisar",
        "sessionStartedAt": "Sessão iniciada em",
        "stats": {
            "totalUsers": "Total de utilizadores"
        },
        "title": "Jogadores Conectados",
        "updatedAt": "Atualizado em",
        "userName": "Nome do utilizador"
    },
    "loggedAgentsAdmins": {
        "appId": "App ID",
        "browser": "Navegador",
        "bulk": {
            "confirmLogout": "Terminar sessão de {count} utilizador(es) selecionado(s)?",
            "confirmReloadTool": "Recarregar ferramenta para {count} utilizador(es) selecionado(s)?",
            "logout": "Terminar sessão",
            "reloadTool": "Recarregar ferramenta"
        },
        "connectionId": "ID",
        "ip": "IP",
        "os": "SO",
        "pageUrl": "URL atual",
        "role": "Função",
        "search": "Pesquisar",
        "sessionStartedAt": "Sessão iniciada em",
        "stats": {
            "totalUsers": "Total de utilizadores"
        },
        "title": "Agentes/Admins Conectados",
        "updatedAt": "Atualizado em",
        "userName": "Nome do utilizador"
    },
    "login": {
        "forgotPassword": "Esqueceu sua senha",
        "inactive": "Sua conta está inativa, entre em contato <a style=\"color: #ef3b3a\" href=\"mailto:support@tradeball.com\">support@tradeball.com</a>.",
        "incorrect": "Login ou senha incorretos",
        "login": "Entrar",
        "notVerified": "Sua conta não foi verificada",
        "password": "Senha",
        "registration": "Cadastrar",
        "successful": "Inicio de sesión exitoso",
        "tokenInvalid": "Token inválido o no existe",
        "username": "Nome do usuário",
        "verifyEmail": "por favor, verifique o seu endereço de e-mail"
    },
    "mappingProblem": {
        "accept": "Aceitar",
        "awayTeam": "Equipa Visitante",
        "bookmaker": "Bookmaker",
        "canBeAutoFixed": "Pode ser corrigido automaticamente",
        "collapse": "Recolher",
        "confirmAccept": "Tem certeza de que deseja aceitar a solução \"{description}\"?",
        "createdDateFilter": "Data de criação",
        "customEventIds": "IDs Custom de Evento",
        "date": "Data",
        "description": "Descrição",
        "eventDate": "Data do Evento",
        "eventId": "ID do Evento",
        "eventIds": "IDs de Evento",
        "events": "Eventos",
        "expand": "Expandir",
        "expandAll": "Expandir todas as soluções",
        "homeTeam": "Equipa da Casa",
        "id": "ID",
        "league": "Liga",
        "noSolutions": "Nenhuma solução",
        "possibleSolutions": "Possíveis soluções",
        "problem": "Problema",
        "problemBookmaker": "Bookmaker do Problema",
        "problemInfo": "Informações do problema",
        "resolvedAt": "Resolvido em",
        "search": "Pesquisar",
        "solutionDescription": "Possível solução",
        "solutionStatus": "Status da Solução",
        "status": "Status",
        "statusFilter": "Status",
        "title": "Problemas de Mapeamento",
        "type": "Tipo",
        "typeFilter": "Tipo"
    },
    "menu": {
        "account": "Conta",
        "accounting": "Contabilidade",
        "accounts": "Contas",
        "activity": "Atividade",
        "admin": "Admin",
        "alerts": "Alertas",
        "alertsUserDocuments": "{count} usuário(s) aguardando aprovação",
        "appAlerts": "App Alertas",
        "bets": "Apostas",
        "bookBalance": "Saldo da Casa de Apostas",
        "userBalance": "Saldos de Usuários",
        "report": "Relatórios",
        "bookmaker": "Casas de Apostas",
        "bots": "Bots",
        "botUsageStats": "Usage Stats",
        "changePassword": "Alterar Senha",
        "columnsTab": "Colunas",
        "confirmPassword": "Confirmar Nova Senha",
        "currentPassword": "Senha Atual",
        "customLeagues": "Ligas Personalizadas",
        "customTeam": "Equipes Custom",
        "events": "Jogo",
        "filtersTab": "Filtros",
        "generalSettings": "Geral",
        "hideAll": "Ocultar Todos",
        "language": "Idioma",
        "leagues": "Ligas",
        "leagueDailyCoverage": "Cobertura Diária de Ligas",
        "live": "Ao Vivo",
        "loggedPlayers": "Jogadores Conectados",
        "loggedAgentsAdmins": "Agentes/Admins Conectados",
        "login": "Entrar",
        "logout": "Sair",
        "mappingProblem": "Problemas de Mapeamento",
        "monitoring": "Monitoramento",
        "proxy": "Proxy",
        "noSpecificSettings": "Nenhuma configuração específica para esta página",
        "orders": "Pedidos",
        "notifications": "Notificações",
        "audit": "Audit",
        "exchangeRate": "Taxa de Câmbio",
        "pageVisitHistory": "Histórico de Visitas",
        "pageSettings": "Configurações da Página",
        "password": "Nova Senha",
        "pregame": "Pré-jogo",
        "rememberFilters": "Lembrar Filtros",
        "resetOrder": "Redefinir Ordem",
        "saveFiltersState": "Salvar Estado dos Filtros",
        "searchPlaceholder": "Pesquisar menu...",
        "searchRecent": "Recentes",
        "showAll": "Mostrar Todos",
        "system": "Sistema",
        "team": "Equipes",
        "timeZone": "Fuso Horário",
        "toolUserDetails": "Detalhes de Utilizadores",
        "toolUserDocuments": "Documentos de Utilizadores",
        "toolUserDocumentsShort": "Doc. utiliz…",
        "toolUsers": "Utilizadores",
        "transfer": "Depósitos e Saques",
        "turnover": "Menu",
        "turnoverEvent": "Jogo",
        "turnoverSelection": "Seleção de Apostas",
        "useButtonForFiltersApply": "Usar Botão Aplicar Filtros",
        "visibleColumns": "Colunas Visíveis",
        "visibleFilters": "Filtros Visíveis",
        "wlBalance": "WL Balance",
        "customerPl": "Customer P/L",
        "wlTransaction": "Transações WL",
        "betSettlement": "Liquidação de Apostas"
    },
    "customerPl": {
        "avgBetVsClose": "AVG Bet Vs Close",
        "avgBetVsOpen": "AVG Bet Vs Open",
        "avgStake": "AVG Stake",
        "bookmaker": "Bookmaker",
        "customLeague": "Custom League",
        "customLeagues": "Custom Leagues",
        "datePeriod": {
            "days30": "30 Dias",
            "days60": "60 Dias",
            "days90": "90 Dias",
            "days360": "360 Dias",
            "lifetime": "Lifetime",
            "range": "Intervalo de Datas",
            "title": "Período"
        },
        "lastBet": "Última Aposta",
        "leagueLimits": "Limites de Liga",
        "market": "Mercado",
        "marketType": "Tipo de Mercado",
        "mobile": "Mobile",
        "name": "Nome",
        "pc": "PC",
        "periodType": "Tipo de Período",
        "roi": "ROI",
        "sport": "Sport",
        "totalBets": "#Total Apostas",
        "totalPl": "Total P/L",
        "totalStake": "Total Stake",
        "user": "User"
    },
    "monitoring": {
        "accounts": "Alocação de Contas",
        "accountsSection": {
            "accounts": "Contas",
            "allocated": "Alocado",
            "bookmaker": "Casa de apostas",
            "disabled": "Desabilitado",
            "free": "Livre",
            "loggedIn": "Conectado",
            "loggedOut": "Desconectado",
            "message": "Mensagem"
        },
        "betting": "Apostas",
        "bettingSection": {
            "accBRL": "Acc R$",
            "accEUR": "Acc €",
            "accHKD": "Acc HK$",
            "accTotal": "Acc Total",
            "accounts": "Contas",
            "activeCredit": "Crédito ativo",
            "activeCreditBRL": "R$ Crédito",
            "activeCreditEUR": "€ Crédito",
            "activeCreditHKD": "HK$ Crédito",
            "bookmaker": "Casa de apostas",
            "groups": "Grupos",
            "maxSharing": "Compartilhamento máximo",
            "proxies": "Proxies",
            "proxyLocations": "Localizações de proxy",
            "total": "TOTAL"
        },
        "parsing": "Parsing",
        "parsingSection": {
            "accounts": "Contas",
            "basketball": "Basquete",
            "early": "Antecipado",
            "feed": "Feed",
            "football": "Futebol",
            "live": "Ao vivo",
            "proxies": "Proxies",
            "proxyLocations": "Localizações de proxy",
            "today": "Hoje"
        },
        "proxy": "Proxy",
        "proxySection": {
            "allocated": "Alocado",
            "free": "Livre",
            "mostAllocated": "Mais alocado",
            "proxies": "Proxies",
            "proxyLocation": "Localização do proxy",
            "secondMostAllocated": "2º mais alocado",
            "thirdMostAllocated": "3º mais alocado"
        },
        "serverTime": "Hora do Servidor",
        "settlement": "Liquidação",
        "settlementSection": {
            "account": "Conta",
            "bookmaker": "Casa de apostas",
            "game": "Jogo",
            "oldestUnsettledBets": "Apostas não liquidadas mais antigas",
            "unsettledBets": "Apostas não liquidadas"
        },
        "title": "Monitoramento"
    },
    "orders": {
        "any": "Qualquer",
        "attempting": "Tentando",
        "attemptingTopUp": "Tentando top up",
        "available": "Disponível",
        "betType": "Tipo de Aposta",
        "betsDone": "{count} apostas feitas",
        "bookmaker": "Casa de Apostas",
        "closed": "Fechado",
        "correctScore": "Placar Exato",
        "date": "Data",
        "dateClose": "Data de Fechamento",
        "executed": "Executado",
        "executedTooltipBase": "Aposta feita",
        "executedTooltipSuffix": "odds melhores",
        "failed": "Falhou",
        "fillPercent": "Preenchimento %",
        "gameAwayOver": "jogo Fora Mais",
        "gameAwayUnder": "jogo Fora Menos",
        "gameBtsNo": "jogo AEM Não",
        "gameBtsYes": "jogo AEM Sim",
        "gameDrawOrAway": "jogo Empate ou Fora",
        "gameHomeOrAway": "jogo Casa ou Fora",
        "gameHomeOrDraw": "jogo Casa ou Empate",
        "gameHomeOver": "jogo Casa Mais",
        "gameHomeUnder": "jogo Casa Menos",
        "gameOver": "jogo Mais",
        "gameType": "Tipo de Jogo",
        "gameUnder": "jogo Menos",
        "id": "ID",
        "kickOff": "Início",
        "koTime": "Hora KO",
        "market": "Mercado",
        "noBets": "Sem apostas",
        "oneBetDone": "Uma aposta feita",
        "open": "Aberto",
        "order": "Pedido",
        "orderDateFilter": "Data do pedido",
        "orderId": "ID do Pedido",
        "orderStake": "Stake do Pedido",
        "outcome": "Resultado",
        "selected": "Selecionado",
        "status": "Status",
        "timeout": "Timeout",
        "title": "Pedidos",
        "user": "Usuário"
    },
    "audit": {
        "action": "Ação",
        "editedFields": "Campos editados",
        "id": "ID",
        "name": "Nome",
        "objectId": "ID do objeto",
        "source": "Origem",
        "table": "Tipo",
        "time": "Hora",
        "user": "Usuário"
    },
    "pageVisitHistory": {
        "agent": "Agent",
        "appId": "App ID",
        "date": "Data",
        "dateFilter": "Data",
        "dateFirst": "First",
        "dateLast": "Last",
        "get": "GET",
        "number": "#",
        "page": "Página",
        "post": "POST",
        "search": "Pesquisar",
        "source": "Origem",
        "uniqAppId": "Uniq App Id",
        "url": "Url",
        "user": "Usuário"
    },
    "perfLogger": {
        "activeKey": "Chave ativa",
        "clear": "Limpar",
        "clearAll": "Limpar todas as estatísticas",
        "colCount": "Amostras",
        "colKey": "Chave",
        "colLoad": "Load min / max / méd (ms, por item)",
        "colRender": "Render min / max / méd (ms, por item)",
        "colTotal": "Total min / max / méd (ms, por item)",
        "colUndoLast": "Desfazer último",
        "keyHint": "OK ou Enter. Chave vazia para de gravar. Recarregamentos são agrupados pela chave ativa.",
        "keyLabel": "Chave de estatísticas",
        "noData": "Ainda sem amostras",
        "sourceApp": "Reload na app",
        "sourceAppShort": "App",
        "sourcePage": "Entrada na página (mount)",
        "sourcePageShort": "Página",
        "title": "Registo de performance",
        "togglePanel": "Registo de performance",
        "undoLastApp": "Remover última amostra de reload na app",
        "undoLastPage": "Remover última amostra de entrada na página"
    },
    "pregame": {
        "asianHandicap": "Handicap Asiático",
        "away": "Fora",
        "bookmaker": "Casa de Apostas",
        "btsPrices": "AEM",
        "cornersAsianHandicap": "C-HDP",
        "cornersGoal": "C-Gols",
        "cornersGoalLine": "C-Gols",
        "cornersGoalPriceOver": "C-Mais",
        "cornersGoalPriceUnder": "C-Menos",
        "cornersHdpLine": "C-HDP",
        "cornersHdpPriceAway": "C-Fora",
        "cornersHdpPriceHome": "C-Casa",
        "date": "Data",
        "dcPrice": "Chance Dupla",
        "dnb": "DNB",
        "dnbAway": "DNB Fora",
        "dnbHome": "DNB Casa",
        "eventExcludedFromFeeds": "Evento {bookmaker} está excluído dos feeds",
        "eventExcludedFromFeedsWithOthers": "Evento {bookmaker}(+outros bookies) está excluído dos feeds",
        "eventExcludedOnThirdPartyWebsite": "Evento está excluído em um site de terceiros",
        "eventPeriodId": "Período do Evento",
        "eventStartPeriod": "Status do Jogo",
        "excludeBookmakerAndOthersFromFeeds": "Excluir {bookmaker} (+outros bookies) dos feeds",
        "excludeBookmakerFromFeeds": "Excluir {bookmaker} dos feeds",
        "excludeFromAllBookmakers": "Excluir evento de todos os bookmakers",
        "excluded": "Excluído",
        "excludedFromAllBookmakers": "Excluído evento de todos os bookmakers",
        "game": "Jogo",
        "gameDateFilter": "Data do jogo",
        "gameStatus": {
            "finished": "Terminado",
            "firstHalf": "Primeira Parte",
            "live": "Ao Vivo",
            "secondHalf": "Segunda Parte",
            "upcoming": "Próximos dias"
        },
        "goal": "Gol",
        "goalAway": "Gols Fora",
        "goalAwayLine": "Gols Fora",
        "goalAwayPriceOver": "F-O/U Mais",
        "goalAwayPriceUnder": "F-O/U Menos",
        "goalHome": "Gols Casa",
        "goalHomeLine": "Gols Casa",
        "goalHomePriceOver": "C-O/U Mais",
        "goalHomePriceUnder": "C-O/U Menos",
        "goalLine": "Gol",
        "goalPriceOver": "Mais",
        "goalPriceUnder": "Menos",
        "hdpLine": "HDP",
        "hdpPriceAway": "Fora",
        "hdpPriceHome": "Casa",
        "home": "Casa",
        "invert": "Inverter",
        "invertConfirm": {
            "confirm": "Inverter",
            "message": "Importante! O jogo {game} será invertido para {invertedGame} para TODOS os bookmakers"
        },
        "inverted": "Invertido",
        "isInverted": "Invertido",
        "league": "Liga",
        "leagueLimitsCategory": "Categoria de Limites da Liga",
        "line": "Linha",
        "moneyline": "Vencedor da Partida",
        "oneXTwo": "1X2",
        "points": "Total de Pontos",
        "pointsLine": "Pontos",
        "score": "Placar",
        "showOpenPrices": "Preços Abertos",
        "spread": "Handicap de Pontos",
        "spreadLine": "HDP",
        "spreadPriceAway": "Fora",
        "spreadPriceHome": "Casa"
    },
    "rules": {
        "between": "Este campo deve estar entre {min} e {max}",
        "correctScoreFormat": "Formato deve ser X-Y (ex: 2-1) Máximo é 99-99",
        "email": "Endereço de e-mail inválido",
        "emailDoesNotMatch": "Email não corresponde",
        "fileSize": "O tamanho do arquivo deve ser menor que {size} MB",
        "grOrEqual": "{field} Para tem que ser maior ou igual a {field} De",
        "greaterThanValue": "{field} tem de ser maior que {value}",
        "integer": "Este campo deve ser um número inteiro",
        "lsOrEqual": "{field} De tem que ser menor ou igual a {field} Para",
        "max": "O valor máximo para este campo é {value}",
        "maxLength": "Máximo {max} caracteres",
        "min": "O valor mínimo para este campo é {value}",
        "minLength": "Mínimo {min} caracteres",
        "multipleOf": "O valor deve ser múltiplo de {value}",
        "negative": "Este campo não pode ser negativo",
        "newPasswordDoesNotMatch": "A nova senha não corresponde",
        "number": "Este campo tem que ser o número",
        "required": "Requerido"
    },
    "team": {
        "actions": {
            "delete": "Excluir equipe"
        },
        "association": {
            "age": "Idade",
            "associate": "Associar",
            "bookmakerTeam": "Equipe da casa",
            "genre": "Gênero",
            "suggested": "Sugerido",
            "title": "Associar equipe personalizada"
        },
        "associationStatus": {
            "all": "Todas equipes",
            "allNoFantasy": "Todas equipes - sem fantasy",
            "associated": "Com associação",
            "fantasy": "Fantasy",
            "notAssociated": "Sem associação"
        },
        "bookmakerId": "Casa de Apostas",
        "confirmDelete": "Excluir esta equipe?",
        "createdAt": "Criado",
        "customTeamId": "ID da Equipe Custom",
        "filters": {
            "bookmakerId": "Casa de Apostas",
            "customTeamAssociationStatus": "Associação",
            "customTeamId": "Equipe Custom",
            "sportId": "Sport",
            "teamName": "Nome da Equipe"
        },
        "gameCount": "Qtd. Jogos",
        "id": "ID",
        "internalId": "ID Interno",
        "name": "Nome",
        "notAssociated": "Não associado",
        "sportId": "Sport",
        "updatedAt": "Atualizado"
    },
    "toolUserDetails": {
        "actions": {
            "approvalSent": "Aprovação enviada",
            "delete": "Eliminar",
            "sendApproval": "Enviar aprovação"
        },
        "columns": {
            "agent": "Agente",
            "country": "País",
            "currency": "Moeda",
            "date": "Data",
            "documents": "Documentos",
            "email": "E-mail",
            "idProof": "Prova ID",
            "login": "Utilizador",
            "name": "Nome",
            "refUser": "Ref. utilizador",
            "sendEmail": "Enviar e-mail",
            "surname": "Apelido",
            "utilityProof": "Prova utilidade",
            "validIdDoc": "Doc. ID válido",
            "validUtilityDoc": "Doc. utilidade válido"
        },
        "confirmDelete": "Eliminar este utilizador?",
        "confirmSendApproval": "Enviar notificação de aprovação a este utilizador?",
        "documents": {
            "approve": "Verifique!",
            "approved": "Aprovado",
            "waiting": "Em espera"
        },
        "filters": {
            "agent": "Agente",
            "country": "País",
            "currency": "Moeda",
            "documents": "Documentos",
            "documentsApproved": "Aprovado",
            "documentsPleaseCheck": "Verifique!",
            "documentsWaiting": "Em espera",
            "search": "Pesquisar",
            "status": "Estado",
            "statusActive": "Ativo",
            "statusDeleted": "Eliminado",
            "statusInactive": "Inativo"
        },
        "tooltips": {
            "column": {
                "idProof": "Documento de ID aprovado",
                "sendEmail": "Enviar e-mail de aprovação",
                "utilityProof": "Documento utility aprovado",
                "validIdDoc": "Documento de ID é válido",
                "validUtilityDoc": "Documento utility é válido"
            }
        }
    },
    "toolUserDocuments": {
        "actions": {
            "delete": "Eliminar",
            "getFile": "Obter ficheiro"
        },
        "columns": {
            "date": "Data",
            "documentType": "Tipo de documento",
            "file": "Ficheiro",
            "fileName": "Nome do ficheiro",
            "username": "Utilizador",
            "valid": "Válido"
        },
        "confirmDelete": "Eliminar este documento?",
        "filters": {
            "documentType": "Tipo de documento",
            "search": "Pesquisar"
        },
        "tooltips": {
            "valid": "Alternar para marcar o documento como válido"
        },
        "type": {
            "id": "ID",
            "utility": "Utility"
        }
    },
    "toolUsers": {
        "actions": {
            "delete": "Eliminar",
            "send": "Enviar"
        },
        "activation": {
            "sent": "Enviado"
        },
        "columns": {
            "act": "ACT",
            "actBots": "Bots ativos",
            "activation": "Ativação",
            "balance": "Saldo",
            "betBalance": "Saldo apostas",
            "bets": "Apostas",
            "bots": "Bots",
            "c": "C",
            "createdBy": "Criado por",
            "credit": "Crédito",
            "creditLimit": "Limite de crédito",
            "date": "Data",
            "documentsShort": "D",
            "exposure": "Exposição",
            "id": "ID",
            "lastBet": "Última aposta",
            "lastLogin": "Último login",
            "role": "Função",
            "sub": "Sub",
            "suspendedShort": "S",
            "suspiciousShort": "?",
            "transferBal": "Saldo transfer.",
            "username": "Utilizador",
            "verifyEmail": "Verificar e-mail"
        },
        "confirmActivateUser": "Ativar o utilizador {user}?",
        "confirmDeactivateUser": "Desativar o utilizador {user}?",
        "confirmDelete": "Eliminar este utilizador?",
        "positionRules": {
            "add": "Adicionar regra de posição",
            "columns": {
                "active": "Ativo",
                "date": "Data"
            },
            "confirmDelete": "Eliminar esta regra de posição?",
            "form": {
                "createTitle": "Nova regra de posição",
                "editTitle": "Editar regra de posição"
            },
            "noData": "Sem regras de posição.",
            "open": "Regras de posição do utilizador",
            "title": "Regras de posição do utilizador"
        },
        "params": {
            "columns": {
                "param": "Param",
                "value": "Valor"
            },
            "alreadyExists": "Já existe um param com este nome para este utilizador.",
            "paramRequired": "O param é obrigatório.",
            "paramMaxLength": "O param não pode ter mais de {max} caracteres.",
            "valueRequired": "O valor é obrigatório.",
            "valueMaxLength": "O valor não pode ter mais de {max} caracteres.",
            "confirmDelete": "Eliminar este param?",
            "editHint": "Duplo clique para editar",
            "editHintMobile": "Toque para editar",
            "form": {
                "createTitle": "Novo param"
            },
            "loadError": "Não foi possível carregar os params.",
            "noData": "Sem params."
        },
        "confirmSuspendUser": "Suspender o utilizador {user}?",
        "confirmUnsuspendUser": "Remover a suspensão do utilizador {user}?",
        "documents": {
            "approved": "Documentos aprovados",
            "review": "Verificar documentos"
        },
        "filters": {
            "botStatus": "Estado dos bots",
            "botStatusActive": "Bots ativos",
            "botStatusInactive": "Sem bots ativos",
            "search": "Pesquisar",
            "userCurrencyId": "Todas as moedas",
            "userId": "ID do utilizador",
            "userObserveId": "Todos os utilizadores",
            "userOwnerId": "Criado por",
            "userPlatformId": "Todas as plataformas",
            "userStatus": "Estado",
            "userStatusActive": "Ativo",
            "userStatusDeleted": "Eliminado",
            "userStatusInactive": "Inativo",
            "userStatusNotDeleted": "Não eliminado",
            "userStatusSuspended": "Suspenso",
            "userTypeId": "Função"
        },
        "form": {
            "active": "Ativo",
            "agent": "Agente",
            "approvePermission": "Aprovar id/utility permissão",
            "commissionBot": "COMM% Bot",
            "commissionOrder": "COMM% Ordem",
            "country": "País",
            "createTitle": "Criar utilizador",
            "creditLimit": "Limite de crédito",
            "currency": "Moeda",
            "editTitle": "Editar utilizador",
            "email": "E-Mail",
            "firstName": "Nome próprio",
            "irregular": "Irregular",
            "name": "Nome",
            "notSelected": "Não selecionado",
            "note": "Nota",
            "openedBy": "Aberto por",
            "password": "Palavra-passe",
            "passwordKeepCurrent": "Deixe em branco para manter a atual",
            "platform": "Plataforma",
            "positionSectionTitle": "Posição %",
            "positionSectionTitleWl": "Posição WL %",
            "positionBotPerc": "Bot %",
            "positionOrderPerc": "Ordem %",
            "positionBotWlPerc": "Bot WL %",
            "positionOrderWlPerc": "Ordem WL %",
            "positionUserRule": "Regra de utilizador",
            "companyPosition": "Posição da empresa",
            "agentPosition": "Posição do agente",
            "referralLink": "Link de Referência",
            "save": "Guardar",
            "surname": "Apelido",
            "type": "Tipo",
            "typePlaceholder": "Selecione o tipo de utilizador",
            "username": "Nome de utilizador",
            "watch": "Observar"
        },
        "tooltips": {
            "activatedAt": "Ativado em {date} por {by}",
            "activationSentAt": "E-mail de ativação enviado em {date} por {by}",
            "agentReferral": "URL de referência do agente: {ref} — clique no ID para copiar",
            "column": {
                "act": "Ativo — alterna estado ativo da conta",
                "actBots": "Bots ativos",
                "activation": "Ativação — enviar / ver estado do e-mail de ativação",
                "balance": "Saldo total",
                "betBalance": "Saldo em apostas (apostas abertas)",
                "bets": "Apostas colocadas",
                "bots": "Total de bots",
                "c": "Moeda",
                "credit": "Crédito disponível",
                "documents": "Documentos — clique no ícone para abrir a lista de documentos",
                "exposure": "Exposição em aberto",
                "lastBet": "Tempo desde a última aposta",
                "role": "Função do utilizador",
                "sub": "Quantidade de subutilizadores",
                "suspended": "Utilizador suspenso (laranja)",
                "suspicious": "Atividade suspeita",
                "transferBal": "Saldo de transferência",
                "verifyEmail": "Estado de verificação de e-mail"
            },
            "copyReferralLink": "Copiar link de referência",
            "createdByPlatform": "Plataforma: {platform}",
            "deactivatedAt": "Desativado em {date} por {by}",
            "openUserDetails": "Clique para abrir detalhes do jogador",
            "openUsersPage": "Clique para abrir a página Utilizadores",
            "verifyEmailSentAt": "E-mail de verificação enviado em {date} por {by}"
        },
        "verify": {
            "verified": "Verificado"
        }
    },
    "turnoverEvent": {
        "away": "Fora",
        "bets": "Quantidade de Apostas",
        "date": "Data",
        "gameDateFilter": "Data do jogo",
        "gameGrid": {
            "bets": "Apostas",
            "companyGrid": "Company PL",
            "gridMode": "Grid",
            "open": "Game Grid",
            "platform": "Plataforma",
            "playerGrid": "Player PL",
            "position": "Posição",
            "stake": "Stake",
            "title": "Game Grid"
        },
        "home": "Casa",
        "league": "Liga",
        "limitCategory": "Categoria de Limites",
        "minute": "Minuto",
        "notStarted": "Não Iniciado",
        "pl": "P/L do Usuário",
        "playing": "Em Jogo",
        "score": "Placar",
        "settling": "Não Liquidado",
        "settled": "Liquidado",
        "stake": "Aposta do Usuário",
        "status": "Status",
        "unsettledBets": "Apostas Não Liquidadas",
        "users": "Quantidade de Usuários"
    },
    "turnoverSelection": {
        "away": "Fora",
        "bets": "Quantidade de Apostas",
        "date": "Data",
        "gameDateFilter": "Data do jogo",
        "handicap": "Handicap",
        "home": "Casa",
        "league": "Liga",
        "limitCategory": "Categoria de Limites",
        "netPayout": "Max Net Payout",
        "oddsAvg": "Odds Médio",
        "period": "Mercado",
        "pl": "P/L do Usuário",
        "selection": "Seleção",
        "stake": "Aposta do Usuário",
        "unsettledBets": "Apostas Não Liquidadas",
        "users": "Quantidade de Usuários"
    },
    "user": {
        "passwordDoesNotMatchCurrent": "A senha fornecida não corresponde à senha atual",
        "passwordSuccessChanged": "A senha foi alterada com sucesso",
        "passwordsDontMatch": "As senhas não correspondem",
        "playerEmailAlreadyExist": "Já existe um jogador com este e-mail",
        "timezoneSuccessChanged": "O fuso horário foi alterado com sucesso"
    },
    "virtualMarket": {
        "correctScore": "Placar",
        "date": "Data",
        "handicap": "Handicap",
        "jollywhere": "Jollywhere",
        "line": "Linha",
        "marketTypeLive": {
            "bts": "Ao Vivo Mercado Virtual Ambos Marcam",
            "cornersGoal": "Ao Vivo Mercado Virtual Over/Under de Escanteios",
            "cornersHandicap": "Ao Vivo Mercado Virtual Handicap Asiático de Escanteios",
            "cs": "Ao Vivo Mercado Virtual Resultado Exato",
            "dc": "Ao Vivo Mercado Virtual Chance Dupla",
            "drawNoBet": "Ao Vivo Mercado Virtual Empate Anula",
            "goal": "Ao Vivo Mercado Virtual Over/Under",
            "goalAway": "Ao Vivo Mercado Virtual Gols Fora",
            "goalHome": "Ao Vivo Mercado Virtual Gols Casa",
            "handicap": "Ao Vivo Mercado Virtual Handicap Asiático",
            "moneyline": "Ao Vivo Mercado Virtual Moneyline",
            "oneXTwo": "Ao Vivo Mercado Virtual 1X2",
            "spread": "Ao Vivo Mercado Virtual Spread"
        },
        "marketTypePregame": {
            "bts": "Pré-Jogo Mercado Virtual Ambos Marcam",
            "cornersGoal": "Pré-Jogo Mercado Virtual Over/Under de Escanteios",
            "cornersHandicap": "Pré-Jogo Mercado Virtual Handicap Asiático de Escanteios",
            "cs": "Pré-Jogo Mercado Virtual Resultado Exato",
            "dc": "Pré-Jogo Mercado Virtual Chance Dupla",
            "drawNoBet": "Pré-Jogo Mercado Virtual Empate Anula",
            "goal": "Pré-Jogo Mercado Virtual Over/Under",
            "goalAway": "Pré-Jogo Mercado Virtual Gols Fora",
            "goalHome": "Pré-Jogo Mercado Virtual Gols Casa",
            "handicap": "Pré-Jogo Mercado Virtual Handicap Asiático",
            "moneyline": "Pré-Jogo Mercado Virtual Moneyline",
            "oneXTwo": "Pré-Jogo Mercado Virtual 1X2",
            "spread": "Pré-Jogo Mercado Virtual Spread"
        },
        "price": "Preço",
        "score": "Resultado",
        "shortTitle": "MV",
        "stats": {
            "attacks": "Ataques",
            "corners": "Escanteios",
            "dangerousAttacks": "Ataques Perigosos",
            "fouls": "Faltas",
            "hitWoodwork": "Trave",
            "possessionTime": "Tempo de Posse",
            "red": "Vermelho",
            "score": "Placar",
            "shortTitle": "Estatísticas Live",
            "shots": "Chutes",
            "shotsOnTarget": "Chutes no Gol",
            "time": "Tempo",
            "title": "Mercado Virtual de Estatísticas",
            "yellow": "Amarelo"
        },
        "teams": "Equipes",
        "title": "Histórico do Mercado Virtual"
    },
    "wlBalance": {
        "a2fFinalOperation": "Operação Final A2F",
        "balanceAgentBrl": "Saldo Agente BRL",
        "balanceAgentEuro": "Saldo Agente EUR",
        "balanceBookmakerBrl": "Saldo Casa BRL",
        "balanceBookmakerEuro": "Saldo Casa EUR",
        "betCount": "#Apostas",
        "bookFeesBrl": "Taxas Book BRL",
        "bookFeesEuro": "Taxas Book EUR",
        "bookRebateBrl": "Reembolso Book BRL",
        "bookRebateEuro": "Reembolso Book EUR",
        "companyComBrl": "Com Empresa BRL",
        "companyComEuro": "Com Empresa EUR",
        "platform": "Plataforma",
        "playerComBrl": "Com Jogador BRL",
        "playerComEuro": "Com Jogador EUR",
        "playerPl": "P/L Jogador",
        "playerStake": "Stake Jogador",
        "tbBookCommissionsEur": "Comissões TB EUR",
        "tbFinalOperationBrl": "Operação Final TB BRL",
        "tbFinalOperationEur": "Operação Final TB EUR",
        "tbToBookiesBrl": "TB para Casas BRL",
        "tbToBookiesEur": "TB para Casas EUR",
        "tooltips": {
            "a2fFinalOperation": "[WL para TB] menos [P/L Jogador]",
            "betCount": "Número total de apostas",
            "tbBookCommissionsEur": "[Comissões das casas] mais [Reembolso de taxa Matchbook]",
            "tbFinalOperation": "[Saldo Casa] menos [Saldo Agente] menos [Taxas Book] menos [Comissões pagáveis do agente]",
            "tbToBookmakers": "[Saldo Casa] menos [Taxas Book]. Valores negativos indicam pagamentos às casas (incluindo taxas de exchange).",
            "wlToTb": "[TB para Casa] menos [Operação Final TB]"
        },
        "totalEuro": "TOTAL Euro(€)",
        "wlToTb": "WL para TB"
    },
    "wlTransaction": {
        "accept": "Aceitar",
        "amount": "Valor",
        "availableBalance": "Saldo Disponível",
        "betInternalId": "ID Interno da Aposta",
        "canBeAutoFixed": "Pode ser corrigido automaticamente",
        "collapse": "Recolher",
        "confirmAccept": "Tem a certeza de que pretende aceitar a solução \"{description}\"?",
        "createdAt": "Criado",
        "description": "Descrição",
        "events": "Eventos",
        "expand": "Expandir",
        "expandAll": "Expandir todas as soluções",
        "id": "ID da Transação",
        "infoTooltip": "Informação adicional",
        "log": {
            "error": "Falha ao carregar o log da transação",
            "title": "Log de Transação"
        },
        "noSolutions": "Sem soluções",
        "operation": "Operação",
        "possibleSolutions": "Soluções possíveis",
        "problem": "Problema",
        "problemInfo": "Informação do problema",
        "processedAt": "Processado",
        "processingStartedAt": "Processamento Iniciado",
        "resolvedAt": "Resolvido em",
        "search": "Pesquisar Transação",
        "solutionDescription": "Solução possível",
        "solutionStatus": "Estado da solução",
        "status": "Status",
        "statusFilter": "Status",
        "title": "Transações WL",
        "transactionDateFilter": "Data da transação",
        "type": "Tipo",
        "typeFilter": "Tipo",
        "user": "Usuário"
    },
    "betSettlement": {
        "account": "Conta",
        "balance": "Saldo",
        "betDate": "Data da aposta",
        "betId": "ID da aposta",
        "bookBetId": "ID da aposta na casa",
        "bookmaker": "Casa de apostas",
        "bookmakerOdds": "Odds da Casa",
        "date": "Data",
        "dateFilter": "Data",
        "stake": "Stake",
        "stats": {
            "unsettledBets": "Apostas não liquidadas"
        },
        "title": "Liquidação de Apostas",
        "type": "Tipo",
        "validBalance": "Saldo válido",
        "log": {
            "title": "Ver log de liquidação",
            "windowTitle": "Log de Liquidação"
        }
    },
    "leagueDailyCoverage": {
        "columns": {
            "betdaq": "Betdaq",
            "bf": "Betfair",
            "eventsCount": "Jogos",
            "isTradeballNetwork": "Tradeball Network",
            "matchbook": "Matchbook",
            "name": "Ligas",
            "pinna": "Pinnacle",
            "sportId": "Esporte"
        },
        "filters": {
            "date": "Data"
        },
        "stats": {
            "totalLeagues": "Ligas"
        },
        "title": "Cobertura Diária de Ligas"
    },
    "window": {
        "closeAll": "Fechar todas as janelas",
        "minimize": "Minimizar",
        "minimizeAll": "Minimizar todas as janelas",
        "untitled": "Janela"
    },
    "botUsageStats": {
        "columns": {
            "betCount": "# Apostas",
            "betPerc": "% Apostas",
            "botCount": "# Bots",
            "botCountActive": "# Bots Ativos",
            "botPerc": "% Bots",
            "botPercActive": "% Bots Ativos",
            "name": "Nome"
        },
        "sections": {
            "betType": "Tipo de Aposta",
            "conditions": "Condições",
            "options": "Outras Opções",
            "stakeType": "Tipo de Stake"
        }
    }
}
